import React from 'react'

const Subtitle = (props) => {
  return <div>{props.children}</div>
}

export default Subtitle
